import React, { useRef, useEffect, useState } from "react";
import { Tooltip } from "antd";

/**
 * Componente de texto com truncamento e tooltip automático em overflow.
 * @param {string} children - Texto a exibir.
 * @param {number} maxHeight - Altura máxima em px.
 * @param {number} lines - Quantidade de linhas a mostrar antes de cortar.
 */
const EllipsisText = ({ children, maxHeight = 40, lines = 2 }) => {
  const ref = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Detecta overflow vertical
    setShowTooltip(el.scrollHeight > el.clientHeight);
  }, [children, maxHeight, lines]);

  const style = {
    maxHeight: maxHeight,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: lines,
    lineHeight: "1.2em",
    cursor: "pointer",
    whiteSpace: "normal",
    textOverflow: "ellipsis",
  };

  const content = (
    <span ref={ref} style={style}>
      {children}
    </span>
  );

  return showTooltip ? (
    <Tooltip title={children}>{content}</Tooltip>
  ) : (
    content
  );
};

export default EllipsisText;
